export enum BankAccountValidationStatus {
  BANK_DETAILS_VALID = 'Valid',
  BANK_DETAILS_INVALID = 'Invalid',
}

export type CreditVetting = {
  required?: boolean;
  bankAccountValidationStatus?: BankAccountValidationStatus;
  bankAccountValidationAttempts?: number;
};
